import React from 'react';
import { Download } from 'lucide-react';
import { formatINR } from '../../../util/indianCurrency';

const PendingInvoicesPopup = ({ isOpen, onClose,data }) => {
  return (
   
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
        <thead>
          <tr>
            {['Client Name', 'Month', 'Invoice Number', 'Amount', 'Download'].map((h) => (
              <th key={h} style={{ background: '#f9fafb', color: '#374151', fontWeight: 600, padding: '0.65rem 0.75rem', textAlign: 'left', borderBottom: '2px solid #e5e7eb', whiteSpace: 'nowrap' }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((inv) => (
            <tr key={inv.id}>
              <td style={{ padding: '0.65rem 0.75rem', borderBottom: '1px solid #f3f4f6', color: '#4b5563' }}>{inv.client_name}</td>
              <td style={{ padding: '0.65rem 0.75rem', borderBottom: '1px solid #f3f4f6', color: '#4b5563' }}>{inv.month}</td>
              <td style={{ padding: '0.65rem 0.75rem', borderBottom: '1px solid #f3f4f6', color: '#4b5563' }}>{inv.invoice_number}</td>
              <td style={{ padding: '0.65rem 0.75rem', borderBottom: '1px solid #f3f4f6', color: '#4b5563' }}>{formatINR(inv.amount)}</td>
              <td style={{ padding: '0.65rem 0.75rem', borderBottom: '1px solid #f3f4f6' }}>
                <a href={inv.pdf_url} download style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#d97706', fontWeight: 500, textDecoration: 'none' }}>
                  <Download size={14} /> Invoice
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
  );
};

export default PendingInvoicesPopup;
